<template>
  <div class="box p-4">
    <div id="edit-form">
      <div class="col-md-12 px-4 mx-auto">
        <div class="row">
          <div class="col-md-12 col-xs-12 mx-auto">
            <h5>Add a new project</h5>
            <form @submit.prevent="submitData" class="mt-4" v-if="!isSubmitted">
              <div v-if="errorMsg" class="alert alert-danger" role="alert">
                {{ errorMsg }}
              </div>
              <div class="form-group">
                <p for="inputWebsite">Project name</p>
                <input
                  type="text"
                  v-model="name"
                  class="form-control"
                  id="inputWebsite"
                  placeholder="e.g. Company blog"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group">
                <p>Website URL</p>
                <input
                  type="text"
                  v-model="websiteURL"
                  class="form-control"
                  placeholder="e.g. www.your-website.com"
                  autocomplete="off"
                  required
                />
              </div>
              <!-- <div class="form-group" v-if="isHowuku">
                <p>Average website traffic per month</p>
                <select
                  class="custom-select"
                  id="monthlyTraffic"
                  v-model="monthlyTraffic"
                  required
                >
                  <option disabled selected value> No value selected </option>
                  <option value="10000">
                    Up to 10k
                  </option>
                  <option value="50000">
                    Up to 50k
                  </option>
                  <option value="100000">
                    Up to 100k
                  </option>
                  <option value="200000">
                    Up to 200k
                  </option>
                  <option value="500000">
                    Up to 500k
                  </option>
                  <option value="0">
                    Not sure
                  </option>
                </select>
              </div> -->

              <div class="form-group row">
                <div class="col-sm-12">
                  <button
                    type="submit"
                    class="btn btn-first"
                    v-bind:class="{ disabled: isSubmitted }"
                  >
                    <span v-if="!isSubmitted">Add Project</span>
                    <span v-else>Adding Project...</span>
                  </button>
                </div>
              </div>
            </form>
            <div class="text-center" v-else>
              <Loading :message="processMsg"/>
            </div>
          </div>
        </div>
      </div>
      <modal
        name="show-installation-recommendation"
        :adaptive="true"
        width="850px"
        height="90%"
        :clickToClose="false"
      >
        <InstallRecommendation :recommendPlugin="recommendPlugin" :selectedWidgetId="this.selectedWidgetId"/>
      </modal>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
import Loading from '@/components/Loading.vue'
const InstallRecommendation = () => import('@/components/InstallRecommendation.vue')

export default {
  data: function () {
    return {
      name: '',
      isHowuku: false,
      processMsg: '',
      monthlyTraffic: '',
      websiteURL: '',
      feedbackFlag: true,
      recordFlag: true,
      surveyFlag: false,
      goodUrl: null,
      selectedWidgetId: '',
      selectService: true,
      isSubmitted: false,
      errorMsg: '',
      recommendPlugin: ''
    }
  },
  components: {
    Loading,
    InstallRecommendation
  },
  store,
  methods: {
    setFeature(feature) {
      if (feature === 'feedback') {
        this.feedbackFlag = !this.feedbackFlag
      }
      if (feature === 'record') {
        this.recordFlag = !this.recordFlag
      }
      if (feature === 'survey') {
        this.surveyFlag = !this.surveyFlag
      }
      this.haveService()
    },
    validURL(s, protocols) {
      try {
        let url = new URL(s)
        return protocols
          ? url.protocol
            ? protocols.map(x => `${x.toLowerCase()}:`).includes(url.protocol)
            : false
          : true
      } catch (err) {
        return false
      }
    },
    haveService() {
      this.selectService = false
      if (this.recordFlag || this.feedbackFlag || this.surveyFlag) {
        this.selectService = true
      }
      return this.selectService
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },
    async submitData() {
      // remove params
      let tempURL = this.websiteURL
      tempURL = tempURL.split('?')[0]
      // auto-assign protocol if not exist
      if (!this.validURL(tempURL, ['http', 'https'])) tempURL = 'https://' + tempURL

      if (this.isURL(tempURL)) {
        this.websiteURL = tempURL
        if (!this.isSubmitted) {
          this.isSubmitted = true
          let data = { websiteURL: this.websiteURL }
          
          try {
            this.$auditlog({ module: 'project', action: 'add_new_project' })  
            if (this.$isMida) {
              this.$track('add_new_project')
            }
            else howuku.track('add_new_project')
          } catch(e) {}
          
          if (this.isHowuku) {
            // website CMS check
            this.$http.post(process.env.API_ENDPOINT + '/checkWebsite', data)
              .then((response) => {
                this.recommendPlugin = response.data
                this.isSubmitted = false
                this.createWidget()
              })
              .catch((err) => {
                this.isSubmitted = false
                this.errorMsg = 'Error checking website CMS'
                console.log(err)
              })
          } else {
            this.createWidget()
          }
        }
      } else {
        this.isSubmitted = false
        this.errorMsg = 'Incorrect website URL format'
      }
    },
    isURL(str) {
      var pattern = new RegExp(
        '[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,9}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)|localhost',
        'ig'
      )
      return pattern.test(str)
    },
    filterUrl() {
      if (typeof this.websiteURL === 'undefined') return

      if (this.websiteURL !== '' && this.websiteURL.includes('http')) {
        this.websiteURL = this.websiteURL.split('://')[1]
        this.websiteURL = this.websiteURL.split('/')[0]
      }

      if (this.websiteURL.startsWith('www.')) {
        this.websiteURL = this.websiteURL.replace('www.', '')
      }

      this.websiteURL = this.websiteURL.replace('/', '')
      this.websiteURL = this.websiteURL.replace(' ', '')
    },
    createWidget() {
      let data = {
        widget_name: this.name,
        widget_description: '',
        widget_allowed_website: this.websiteURL,
        widget_webhook: '',
        widget_position: 'right',
        widget_style: 'howu',
        widget_email: '',
        widget_color: '#2167f5',
        widget_minimized_text: 'Feedback',
        widget_email_flag: true,
        widget_skip_comment: 0,
        record_flag: this.recordFlag,
        feedback_flag: this.feedbackFlag,
        survey_flag: this.surveyFlag,
        monthly_average_traffic: this.monthlyTraffic || 0,
        analytic_flag: this.analyticFlag,
        record_active_flag: false,
        record_long_flag: false,
        widget_question_text: 'How would you rate your experience?',
        widget_comment_text: 'Tell us about your experience.',
        widget_email_text:
          'Enter your email address if you would like to receive a follow up.',
        widget_thankyou_text: 'Thank you for your feedback.'
      }

      this.$http
        .post(process.env.API_ENDPOINT + '/addWidget', data)
        .then((response) => {
          let newwidgetid = response.data.widget_id
          this.selectedWidgetId = newwidgetid
          if (newwidgetid) {
            this.$http
              .post(process.env.API_ENDPOINT + '/addPermission', {
                user_id: this.$session.get('user_id'),
                widget_id: newwidgetid
              })
              .then(() => {})
              .finally(() => {
                this.isSubmitted = false
                if (this.isHowuku) this.$modal.show('show-installation-recommendation')
                else this.$modal.hide('show-create-website')
              })
          }
        })
    }
  },
  beforeMount() {
    // if not new user redirect to dashboard
    if (!this.$session.get('new_user')) {
      // this.$router.push({ path: '/dashboard' })
    }
  },
  mounted() {
    if (this.$isMida || this.$isHowuku || this.$isOptimize || window.location.host.includes('localhost')) {
      this.processMsg = 'Checking for the website, it might take a few seconds...'
      this.isHowuku = true
    }
    document.getElementById('inputWebsite').focus()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/CreateWebsite.vue